import React from "react";
import DataGrid from "../../../../../../dataGrid/index";
import GridConfig from "./Grid/GridConfig";
import { withUserProfile } from "../../../../../../../userProfile/userProfileContext";
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import styles from "./styles";
import { withStyles } from "@material-ui/core";
import FooterDetails from "./Grid/components/FooterDetails";
import GridError from "./Grid/components/GridError";
import {
  getShipmentErrorInfo,
  getDefaultShipment,
  getDefaultShipmentError,
  isEmptyShipmentObj,
} from "./utils";

class ShipmentInfoForm extends React.Component {
  constructor(props) {
    super(props);
    this.gridConfig = new GridConfig(
      this.props.userData.userProfile,
      this.props.title
    );
    this.gridApi = {};
  }

  onGridReady = ({ api }) => {
    this.gridApi = api;
    this.gridApi.mode = this.props.mode;
    this.gridApi.isDataUpdatedOnGrid = false;
    this.gridApi.redrawRows();
    this.props.onGridReady(api);
  };

  componentDidUpdate() {
    if (!this.gridApi.isDataUpdatedOnGrid) {
      this.gridApi.isDataUpdatedOnGrid = true;
    }
  }

  getAllRows() {
    let rowData = [];
    this.gridApi.forEachNode((node) => rowData.push(node.data));
    return rowData;
  }

  onAddRow = () => {
    const { shipments, shipmentsErrors } = this.props.shipmentInfo;
    const newShipments= [...shipments, getDefaultShipment()];
    const newShipmentsErrors= [...shipmentsErrors, getDefaultShipmentError()];
    if (shipments.length !== 0 && isEmptyShipmentObj(shipments.at(-1)));
    else {
      this.props.handleChange(
        "shipmentInfo",
        newShipments,
        newShipmentsErrors
      );
    }
    this.enableCellForEditing();
  };

  updateShipmentInfo = () => {
    const shipments = this.getAllRows();
    const newShipmentsErrors = getShipmentErrorInfo(shipments, this.props.mode);
    this.props.handleChange(
      "shipmentInfo",
      shipments,
      newShipmentsErrors,
    );
  };

  onRemoveRow = () => {
    const selectedRows = this.gridApi.getSelectedRows();
    this.gridApi.updateRowData({ remove: selectedRows });
    this.updateShipmentInfo();
  };

  updateLocationInGrid = (params) => {
    const data = params.newValue;
    params.data["destinationZip"] = data.zip || "";
    params.data["destinationState"] = data?.state || "";
    params.data["destinationCity"] = data?.city || "";
    params.data["destinationTerminal"] = data?.terminalCode || "";
    this.gridApi.refreshCells({
      rowNodes: [params.node],
      columns: [
        "destinationZip",
        "destinationState",
        "destinationCity",
        "destinationTerminal",
      ],
      force: true,
    });
    this.updateShipmentInfo();
  };

  onCellValueChanged = (params) => {
    const { field } = params.colDef;
    if (field === "destinationZip") {
      if (params.oldValue && !params.newValue) {
        return;
      } else {
        this.updateLocationInGrid(params);
        return;
      }
    }
    this.gridApi.refreshCells({ columns: [params.colDef], force: true });
    this.updateShipmentInfo();
  };

  enableCellForEditing = () => {
    setTimeout(() => {
      this.gridApi.forEachNode(({ data, rowIndex }) => {
        if (isEmptyShipmentObj(data)) {
          this.gridApi.setFocusedCell(rowIndex, "handlingUnits");
          this.gridApi.startEditingCell({
            rowIndex: rowIndex,
            colKey: "handlingUnits",
          });
        }
      });
    },100);
  };

  onCellEditingStarted = (params) => {
    params.node.setSelected(true);
  };

  onTabToNextCell = ({nextCellPosition}) => {
    if (nextCellPosition) {
      return nextCellPosition;
    }
    const { shipments } = this.props.shipmentInfo;
    if (!nextCellPosition && !isEmptyShipmentObj(shipments.at(-1))) {
      this.onAddRow();
    }
    return null;
  }

  suppressTabKeyInZipDropdown = (params) => {
    const KEY_TAB = 9;
    const { keyCode } = params.event || {};
    if (params.column.colId === "destinationZip") {
      return keyCode === KEY_TAB && this.gridApi.suppressTab; 
    }
    return false;
  }

  render() {
    const {
      shipmentInfo: { shipments, shipmentsErrors },
      classes,
      mode,
    } = this.props;
    const data = shipments.length > 0 ? shipments.slice() : [];
    return (
      <div className={`${classes.container} customScroll`}>
        <div className={classes.headerStyle}>
          <span className={classes.headerLabel}>Shipment Info</span>
        </div>
        <div className={classes.dataGrid}>
          <DataGrid
            defaultColDef={this.gridConfig.config.defaultColDef}
            columnDefs={this.gridConfig.config.columns}
            columnTypes={this.gridConfig.config.columnTypes}
            config={this.gridConfig.config}
            rowSelection={this.gridConfig.config.rowSelection}
            rowDeselection={this.gridConfig.config.rowDeselection}
            rowData={data}
            onGridReady={this.onGridReady}
            onCellDoubleClicked={this.onDoubleClicked}
            isExternalFilterPresent={true}
            onCellValueChanged={this.onCellValueChanged}
            onCellEditingStarted={this.onCellEditingStarted}
            tabToNextCell = {this.onTabToNextCell}
            suppressKeyboardEvent = {this.suppressTabKeyInZipDropdown}
          />
        </div>
        <FooterDetails
          data={data}
          mode={mode}
          onAddRow={this.onAddRow}
          onRemoveRow={this.onRemoveRow}
        />
        <GridError shipmentsErrors={shipmentsErrors} />
      </div>
    );
  }
}
export default compose(
  withUserProfile,
  withSnackbar,
  withStyles(styles)
)(ShipmentInfoForm);
